import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import clsx from 'clsx';
import { FirstLevelNavbarContent } from './components/first-level-navbar-content/FirstLevelNavbarContent';
import { MoreLevelNavbarContent } from './components/more-level-navbar-content/MoreLevelNavbarContent';
import { useLevelNavbarGroup } from './hooks/useLevelNavbarGroup';

export type NavbarContentProps = {
  className?: string;
};

export function NavbarContent(props: NavbarContentProps) {
  const { className } = props;

  const isDebugPanelOpen = useAppearanceConfigModelStore((x) => x.isOpenDebugPanel);
  const navigation = useDocsDataModelStore((x) => x.navigation);
  const { firstLevelNavbarGroup, secondLevelNavbarGroup, thirdLevelNavbarGroup } =
    useLevelNavbarGroup(navigation);

  return (
    <div
      className={clsx(
        '_navbar sticky top-0 z-20 mx-auto my-0 flex w-full flex-col',
        {
          ['as:max-w-[1800px]']: isDebugPanelOpen,
        },
        className,
      )}
    >
      <FirstLevelNavbarContent
        firstLevelNavbarGroup={firstLevelNavbarGroup}
        navigation={navigation}
      />

      <MoreLevelNavbarContent
        secondLevelNavbarGroup={secondLevelNavbarGroup}
        thirdLevelNavbarGroup={thirdLevelNavbarGroup}
      />
    </div>
  );
}
